import { alpha, Box, styled } from '@mui/material';
import { pxToRem } from '@themes';
var ErrorContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: alpha(theme.palette.cornflowerBlue.main, 0.06),
    padding: theme.spacing(4, 3.5),
    borderRadius: pxToRem(24)
  };
  return styles;
});
var IconContainer = styled(Box)(function (_ref2) {
  var theme = _ref2.theme;
  var styles = {
    backgroundColor: alpha(theme.palette.cornflowerBlue.main, 0.2),
    padding: theme.spacing(1),
    borderRadius: pxToRem(16),
    lineHeight: 0
  };
  return styles;
});
export { ErrorContainer, IconContainer };